/*
 leads to a POST or PUT request.
 @id is optional (can be null or undefined)
*/
export const itemSaveRequest = type => (
    id,
    item,
    image,
    callbackActionCreator
) => ({
    type,
    id,
    item,
    image,
    callbackActionCreator
})

export const itemSaveResponse = type => item => ({ type, item })

export const itemSaveErrorResponse = type => (
    error,
    item,
    callbackActionCreator
) => ({
    type,
    error,
    item,
    callbackActionCreator
})

export const itemRequest = type => (
    id,
    isInvalidating,
    callbackActionCreator
) => ({
    type,
    id,
    isInvalidating,
    callbackActionCreator
})

export const itemResponse = type => (
    data,
    isInvalidating,
    callbackActionCreator
) => ({
    type,
    data,
    isInvalidating,
    callbackActionCreator,
    receivedAt: Date.now()
})

export const itemCachedResponse = type => (data, callbackActionCreator) => ({
    type,
    data,
    callbackActionCreator
})

export const itemErrorResponse = type => (
    error,
    id,
    callbackActionCreator
) => ({
    type,
    error,
    id,
    callbackActionCreator
})

export const itemDeleteRequest = type => (id, callbackActionCreator) => ({
    type,
    id,
    callbackActionCreator
})

export const itemSubresourceDeleteRequest = type => (
    resourceID,
    subresourceID,
    callbackActionCreator
) => ({
    type,
    resourceID,
    subresourceID,
    callbackActionCreator
})

export const itemDeleteResponse = itemDeleteRequest
export const itemDeleteErrorResponse = itemErrorResponse
